var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Feedback"},[_vm._v(" Feedback ")])
}
var staticRenderFns = []

export { render, staticRenderFns }